export default function invertArr(arr) {
    var ret = [];
    for(var i = arr.length-1; i >= 0; i--) {
        ret.push(arr[i]);
    }
    return ret;
}